export type SalesAnalytics = {
    [year: string]: {
        [month: string]: {
            total_deals: number;
            total_revenue: string | number;
            customer_acquired: number;
            conversion_rate: number;
        };
    };
};

export const processGraphData = (salesAnalytics: SalesAnalytics) => {
    const years = Object.keys(salesAnalytics);
    const months: string[] = [];
    const totalDeals: number[] = [];
    const totalRevenue: number[] = [];
    const customersAcquired: number[] = [];
    const conversionRates: number[] = [];

    years.forEach((year) => {
        const monthsData = salesAnalytics[year];
        Object.keys(monthsData).forEach((month) => {
            months.push(`${month} ${year}`);
            totalDeals.push(monthsData[month].total_deals);
            totalRevenue.push(parseFloat(String(monthsData[month].total_revenue)));
            customersAcquired.push(monthsData[month].customer_acquired);
            conversionRates.push(monthsData[month].conversion_rate);
        });
    });

    return { months, totalDeals, totalRevenue, customersAcquired, conversionRates };
};